module.exports = __webpack_public_path__ + "media/images/Responsabilité sociale-95c7df7fbdf10099588144185f6a6627.svg";